/**
 * /app/trusts/$id/distributions — Distribution ledger (route shell).
 *
 * Screen impl in `./distributions-screen.tsx`, lazy-loaded via
 * `lazyRouteComponent`. A deep trust sub-tab (ledger + governance vote +
 * treasury payout + resolution-link modals), not a first-paint route, so the
 * body leaves the entry bundle (200 kB gzip budget). Same shell+screen pattern
 * as the sibling `./documents.tsx` / `./audit.tsx` / `./loa-low.tsx` tabs. The
 * committed routeTree.gen.ts imports only `Route` from here, so no plugin regen
 * is needed (which would rewrite the hand-edited custom URLs).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/distributions')({
  component: lazyRouteComponent(() => import('./distributions-screen'), 'DistributionsScreen'),
});
